import { useState } from "react"
import { Link } from "react-router-dom"

/* form */
import Input from "../../../shared/components/form/input"
import FormLayout from "../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../shared/components/FormLayout/FormSection"
import Button from "../../../shared/components/Button/Button"


function FormCommission({ handleSubmit, commissionData, btnText, btCancelLink, btCancelAction, title }) {

    const [commission, setCommission] = useState(commissionData || {})

    function handleChange(e) {
        setCommission({ ...commission, [e.target.name]: e.target.value })
    }

    function submit(e) {
        e.preventDefault()
        handleSubmit(commission)
    }

    return (
        <FormLayout
            title={title}
            onSubmit={submit}
            actions={
                <>
                    <Button variant="save" type="submit">{btnText || 'Salvar'}</Button>
                    {btCancelLink
                        ? <Link className="link-default" to={btCancelLink}><Button variant="cancel">Cancelar</Button></Link>
                        : btCancelAction && <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>
                    }
                </>
            }
        >
            <FormSection>
                <div className="fl-row">
                    <div className="fl-col-mid form-group">
                        <Input
                            text="Valor da comissão em porcentagem"
                            type="number"
                            name="commission"
                            placeholder="Comissão"
                            handleOnChange={handleChange}
                            value={commission.commission || ''}
                        />
                    </div>
                    <div className="fl-col-mid form-group">
                        <Input
                            text="Valor do desconto em porcentagem"
                            type="number"
                            name="discount"
                            placeholder="Desconto"
                            handleOnChange={handleChange}
                            value={commission.discount || ''}
                        />
                    </div>
                </div>
            </FormSection>
        </FormLayout>
    )
}

export default FormCommission
